// 小程序消息
import { memo } from "react";
import styles from "./index.less";
import { MiniProgramMessage as MiniProgramMessageType } from "../types";

type MiniProgramMessageProps = {
  msg: MiniProgramMessageType;
};

const MiniProgramMessage = (props: MiniProgramMessageProps) => {
  const { msg } = props;
  const { title, desc, iconUrl } = msg;

  return (
    <div className={styles["content-mini-program"]}>
      <div className={styles.top}>
        <div className={styles.title}>
          <div className={styles.icon}>
            <img src={iconUrl} alt="" className={styles["icon-content"]} />
          </div>
          {title}
        </div>
        {desc && <div className={styles.desc}>{desc}</div>}
        <div className={styles.content}>
          <img src={iconUrl} alt="" className={styles["mini-program-img"]} />
        </div>
      </div>
      <div className={styles.bottom}>小程序</div>
    </div>
  );
};

export default memo(
  MiniProgramMessage,
  (prevProps, nextProps) =>
    prevProps?.msg?.title === nextProps?.msg?.title &&
    prevProps?.msg?.desc === nextProps?.msg?.desc &&
    prevProps?.msg?.iconUrl === nextProps?.msg?.iconUrl
);
